import { render, staticRenderFns } from "./tempBersara.vue?vue&type=template&id=ff252982&"
import script from "./tempBersara.vue?vue&type=script&lang=js&"
export * from "./tempBersara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports